
const ALCDelaration = ({setShowALCModal}) =>{
return (
  <div className="bg-white p-2 w-[600px] rounded-xl  mx-auto mt-2">
      
      <h2 className="text-xl font-bold mb-1 text-red-600">
        ALC Count Below Acceptable Range
      </h2>

      <p className="mb-1 text-gray-700">
        The value entered is less than acceptable range of 
        <strong> 2 × 10⁹ cells</strong>.
      </p>

      <p className="text-gray-700 mb-2">
        As per process requirements, please review and confirm the following declaration.
      </p>

      {/* Declaration Box */}
      <div className="border p-4 rounded-md mb-5 bg-gray-50">
        <p className="font-medium mb-2">
          I declare that the ALC count in the Leukapheresis Starting Material falls below the 
          acceptance criteria and ImmunoACT to go ahead with manufacturing of CAR-T product 
          using the same LSM. If required or target dose is not achieved, we agree to conduct 
          re-apheresis (if feasible) for the said patient.
        </p>
      </div>

      {/* Modal Footer */}
      <div className="flex justify-end gap-3">
        <button
          className={`px-4 py-2 rounded-lg text-white bg-blue-600`}
          onClick={() => {
            setShowALCModal(false);
          }}
        >
          OK
        </button>
      </div>
  </div>
)
}
export default ALCDelaration